import React from "react";
import Header from "./Header";
import Footer from "./Footer";

const About = () => {
  return (
    <>
      <Header />

      <a id="eltdf-back-to-top" href="#">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="43.047px" height="43.031px" viewBox="0 0 43.047 43.031" xmlSpace="preserve">
          <circle fill="none" stroke="#BC9A6B" strokeMiterlimit="10" cx="21.523" cy="21.531" r="20.986"/>
          <circle fill="none" stroke="#BC9A6B" className="eltdf-popout" strokeMiterlimit="10" cx="21.523" cy="21.531" r="16.049"/>
          <polyline fill="none" stroke="#BC9A6B" strokeMiterlimit="10" points="15.205,23.875 21.523,18.573 27.842,23.875 "/>
        </svg>
      </a>

      <div className="eltdf-content">
        <div className="eltdf-content-inner">

          {/* Hero Title */}
          <div
            className="eltdf-title-holder eltdf-centered-type eltdf-title-va-header-bottom eltdf-preload-background eltdf-has-bg-image eltdf-bg-parallax"
            style={{height: "530px", backgroundColor: "#0c1315", backgroundImage: "url(https://laurent.qodeinteractive.com/wp-content/uploads/2019/12/About-us-title-img.jpg)"}}
            data-height="530"
          >
            <div className="eltdf-title-image">
              <img itemProp="image" src="https://laurent.qodeinteractive.com/wp-content/uploads/2019/12/About-us-title-img.jpg" alt="About Us" />
            </div>
            <div className="eltdf-title-wrapper" style={{height: "420px", paddingTop: "110px"}}>
              <div className="eltdf-title-inner">
                <div className="eltdf-grid">
                  <div className="eltdf-title-holder-inner">
                    <div className="eltdf-title-decor">
                      <svg xmlns="http://www.w3.org/2000/svg" width="41.125" height="9.146">
                        <path fill="none" stroke="#9C7C57" strokeMiterlimit="10" d="M40.881 8.576L20.562.591.244 8.576"/>
                        <path fill="none" stroke="#9C7C57" strokeMiterlimit="10" d="M40.881.591L20.562 8.576.243.591"/>
                      </svg>
                    </div>
                    <h1 className="eltdf-page-title entry-title">About Us</h1>
                    <div className="eltdf-title-decor">
                      <svg xmlns="http://www.w3.org/2000/svg" width="41.125" height="9.146">
                        <path fill="none" stroke="#9C7C57" strokeMiterlimit="10" d="M40.881 8.576L20.562.591.244 8.576"/>
                        <path fill="none" stroke="#9C7C57" strokeMiterlimit="10" d="M40.881.591L20.562 8.576.243.591"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="eltdf-full-width">
            <div className="eltdf-full-width-inner">
              <div className="eltdf-grid-lines-holder eltdf-grid-columns-5">
                <div className="eltdf-grid-line eltdf-grid-column-1"></div>
                <div className="eltdf-grid-line eltdf-grid-column-2"></div>
                <div className="eltdf-grid-line eltdf-grid-column-3"></div>
                <div className="eltdf-grid-line eltdf-grid-column-4"></div>
                <div className="eltdf-grid-line eltdf-grid-column-5"></div>
              </div>

              <div className="eltdf-grid-row">
                <div className="eltdf-page-content-holder eltdf-grid-col-12">
                  <div className="wpb-content-wrapper">

                    {/* Three Column Row: SVG Pattern | Text | Image */}
                    <div className="eltdf-row-grid-section-wrapper eltdf-content-aligment-center">
                      <div className="eltdf-row-grid-section">
                        <div className="vc_row wpb_row vc_row-fluid">
                          
                          {/* Left: SVG Pattern */}
                          <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-3 vc_col-md-12">
                            <div className="vc_column-inner">
                              <div className="wpb_wrapper">
                                <div className="eltdf-elements-holder eltdf-one-column eltdf-responsive-mode-768">
                                  <div className="eltdf-eh-item" data-item-class="eltdf-eh-custom-3156">
                                    <div className="eltdf-eh-item-inner">
                                      <div className="eltdf-eh-item-content eltdf-eh-custom-3156" style={{padding: "60% 0 0 0"}}>
                                        <div className="eltdf-single-image-holder eltdf-svg-pattern eltdf-image-appear-none">
                                          <div className="eltdf-si-inner">
                                            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                              width="303.083px" height="305.563px" viewBox="0 0 303.083 305.563" xmlSpace="preserve">
                                              <path fill="none" stroke="#9A7D57" strokeWidth="1.5" strokeMiterlimit="10" d="M36.927,251.827L1.428,190.62L72.426,67.954
                                                L53.591,35.415 M36.927,251.827l35.499-61.207L12.86,87.705 M107.925,6.621l35.499,61.333L72.426,190.62l65.733,113.572
                                                M85.728,290.305l57.696-99.685L72.426,67.954l35.47-61.282 M176.85,3.041l37.572,64.913L143.424,190.62l60.398,104.352
                                                M148.419,304.655l66.003-114.035L143.424,67.954L180.614,3.7 M281.166,75.306L214.422,190.62l41.37,71.478
                                                M233.9,279.635l51.521-89.015L214.422,67.954l23.047-39.817 M302.023,161.937L285.42,190.62l7.581,13.098"/>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Center: Text Content */}
                          <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-6 vc_col-md-12">
                            <div className="vc_column-inner">
                              <div className="wpb_wrapper">
                                <div className="eltdf-elements-holder eltdf-three-columns eltdf-responsive-mode-1024">
                                  <div className="eltdf-eh-item" data-item-class="eltdf-eh-custom-6106">
                                    <div className="eltdf-eh-item-inner">
                                      <div className="eltdf-eh-item-content eltdf-eh-custom-6106" style={{padding: "0 21%"}}>

                                        {/* Section Title */}
                                        <div className="eltdf-section-title-holder eltdf-st-decor-animation" style={{textAlign: "center"}}>
                                          <div className="eltdf-st-inner">
                                            <span className="eltdf-st-tagline">Restaurant life</span>
                                            <div className="eltdf-st-title-holder">
                                              <div className="decor">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="41.125" height="9.146">
                                                  <path fill="none" stroke="#9C7C57" strokeMiterlimit="10" d="M40.881 8.576L20.562.591.244 8.576"/>
                                                  <path fill="none" stroke="#9C7C57" strokeMiterlimit="10" d="M40.881.591L20.562 8.576.243.591"/>
                                                </svg>
                                              </div>
                                              <h2 className="eltdf-st-title">About Us</h2>
                                              <div className="decor">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="41.125" height="9.146">
                                                  <path fill="none" stroke="#9C7C57" strokeMiterlimit="10" d="M40.881 8.576L20.562.591.244 8.576"/>
                                                  <path fill="none" stroke="#9C7C57" strokeMiterlimit="10" d="M40.881.591L20.562 8.576.243.591"/>
                                                </svg>
                                              </div>
                                            </div>
                                            <p className="eltdf-st-text">
                                              Lorem ipsum dolor sit amet, consecte turn se adipisicing elit, sed do eiusmod tempor ens incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exerci reprehenderit in voluptate velit esse cillu sint occaecat error sit volu.
                                            </p>
                                          </div>
                                        </div>

                                        <div className="vc_empty_space" style={{height: "12px"}}><span className="vc_empty_space_inner"></span></div>

                                        <div className="wpb_text_column wpb_content_element">
                                          <div className="wpb_wrapper">
                                            <p>Cupidatat non proident, sunt in culpa qui cia deserunt mollit anim id est laborum. Sed utsa tat monullamco laboris nisi ut aliquip exe ne com odoconsequat. Duis aute irure dolor in per spiciamt vsun.</p>
                                          </div>
                                        </div>

                                        <div className="vc_empty_space" style={{height: "12px"}}><span className="vc_empty_space_inner"></span></div>

                                        <div className="wpb_text_column wpb_content_element">
                                          <div className="wpb_wrapper">
                                            <p>aperiam, eaque ipsa quae ab illo inventor veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nem odit aut fugit, sed quia consequ un turmagnido lors.</p>
                                          </div>
                                        </div>

                                        <div className="vc_empty_space" style={{height: "38px"}}><span className="vc_empty_space_inner"></span></div>

                                        <a itemProp="url" href="/meet-the-chef" target="_self" className="eltdf-btn eltdf-btn-medium eltdf-btn-simple">
                                          <span className="eltdf-btn-text">Read More</span>
                                        </a>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Right: Photo */}
                          <div className="wpb_column vc_column_container vc_col-sm-12 vc_col-lg-3 vc_col-md-12">
                            <div className="vc_column-inner">
                              <div className="wpb_wrapper">
                                <div className="eltdf-elements-holder eltdf-one-column eltdf-responsive-mode-768">
                                  <div className="eltdf-eh-item" data-item-class="eltdf-eh-custom-6146">
                                    <div className="eltdf-eh-item-inner">
                                      <div className="eltdf-eh-item-content eltdf-eh-custom-6146" style={{padding: "65% 0 0 29px"}}>
                                        <div className="eltdf-single-image-holder eltdf-image-appear-from-top">
                                          <div className="eltdf-si-inner">
                                            <img
                                              fetchPriority="high"
                                              decoding="async"
                                              width="800"
                                              height="800"
                                              src="https://laurent.qodeinteractive.com/wp-content/uploads/2019/10/inner-pages-img-1.jpg"
                                              className="attachment-full size-full"
                                              alt="About us"
                                              srcSet="https://laurent.qodeinteractive.com/wp-content/uploads/2019/10/inner-pages-img-1.jpg 800w, https://laurent.qodeinteractive.com/wp-content/uploads/2019/10/inner-pages-img-1-600x600.jpg 600w, https://laurent.qodeinteractive.com/wp-content/uploads/2019/10/inner-pages-img-1-150x150.jpg 150w, https://laurent.qodeinteractive.com/wp-content/uploads/2019/10/inner-pages-img-1-300x300.jpg 300w, https://laurent.qodeinteractive.com/wp-content/uploads/2019/10/inner-pages-img-1-768x768.jpg 768w, https://laurent.qodeinteractive.com/wp-content/uploads/2019/10/inner-pages-img-1-650x650.jpg 650w, https://laurent.qodeinteractive.com/wp-content/uploads/2019/10/inner-pages-img-1-100x100.jpg 100w"
                                              sizes="(max-width: 800px) 100vw, 800px"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>

                    {/* Video Section */}
                    <div
                      className="eltdf-row-grid-section-wrapper eltdf-parallax-row-holder eltdf-content-aligment-center"
                      data-parallax-bg-image="https://laurent.qodeinteractive.com/wp-content/uploads/2019/12/About-us-video-img.jpg"
                      data-parallax-bg-speed="1"
                    >
                      <div className="eltdf-row-grid-section">
                        <div className="vc_row wpb_row vc_row-fluid">
                          <div className="wpb_column vc_column_container vc_col-sm-12">
                            <div className="vc_column-inner">
                              <div className="wpb_wrapper">
                                <div className="eltdf-video-button-holder">
                                  <div className="eltdf-video-button-image"></div>
                                  <a
                                    className="eltdf-video-button-play"
                                    href="https://vimeo.com/369245407?iframe=true"
                                    data-rel="prettyPhoto[video_button_pretty_photo_527]"
                                  >
                                    <span className="eltdf-video-button-play-inner">
                                      <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="97.094px" height="97.094px" viewBox="0 0 97.094 97.094" xmlSpace="preserve">
                                          <circle fill="none" stroke="currentColor" strokeMiterlimit="10" cx="48.558" cy="48.548" r="48"/>
                                          <circle fill="none" className="eltdf-popout" stroke="none" strokeMiterlimit="10" cx="48.558" cy="48.548" r="41.037"/>
                                          <polygon fill="none" stroke="currentColor" strokeMiterlimit="10" points="42.578,69.964 42.578,27.13 63.994,48.546 "/>
                                        </svg>
                                      </span>
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Testimonials Section */}
                    <div className="vc_row wpb_row vc_row-fluid">
                      <div className="wpb_column vc_column_container vc_col-sm-12">
                        <div className="vc_column-inner">
                          <div className="wpb_wrapper">
                            <div className="eltdf-elements-holder eltdf-one-column eltdf-responsive-mode-768">
                              <div className="eltdf-eh-item" data-item-class="eltdf-eh-custom-8688">
                                <div className="eltdf-eh-item-inner">
                                  <div className="eltdf-eh-item-content eltdf-eh-custom-8688" style={{padding: "0 14%"}}>
                                    <div className="eltdf-testimonials-holder clearfix eltdf-testimonials-standard">
                                      <div className="eltdf-testimonials-mark"></div>
                                      <div
                                        className="eltdf-testimonials eltdf-owl-slider"
                                        data-number-of-items="1"
                                        data-enable-loop="yes"
                                        data-enable-autoplay="yes"
                                        data-slider-speed="5000"
                                        data-slider-speed-animation="600"
                                        data-enable-navigation="yes"
                                        data-enable-pagination="yes"
                                      >
                                        <div className="eltdf-testimonial-content" id="eltdf-testimonials-1542">
                                          <div className="eltdf-testimonial-text-holder">
                                            <p className="eltdf-testimonial-text">
                                              Duis aute irure dolor. Lorem ipsum dolor sit amet, consectetur adipisic sed do eiusmod tempor incidid sens as out labore et. Ut enim ad minim venia quis nostrud exercitation co laboris nisi ut aliquip ex ea commodo conse.
                                            </p>
                                            <h5 className="eltdf-testimonial-author">
                                              <span className="eltdf-testimonials-author-name">Andrea Chung</span>
                                            </h5>
                                            <p className="eltdf-testimonials-author-job">Cook</p>
                                          </div>
                                        </div>

                                        <div className="eltdf-testimonial-content" id="eltdf-testimonials-362">
                                          <div className="eltdf-testimonial-text-holder">
                                            <p className="eltdf-testimonial-text">
                                              Ut enim ad minim venia quis nostrud exercitation co laboris nisi ut aliquip ex ea commodo conse. Duis aute irure dolor. Lorem ipsum dolor sit amet, consectetur adipisic sed do eiusmod tempor incidid sens as out labore et.
                                            </p>
                                            <h5 className="eltdf-testimonial-author">
                                              <span className="eltdf-testimonials-author-name">Andrea Chung</span>
                                            </h5>
                                            <p className="eltdf-testimonials-author-job">Cook</p>
                                          </div>
                                        </div>

                                        <div className="eltdf-testimonial-content" id="eltdf-testimonials-361">
                                          <div className="eltdf-testimonial-text-holder">
                                            <p className="eltdf-testimonial-text">
                                              Lorem ipsum dolor sit amet, consectetur adipisic sed do eiusmod tempor incidid sens as out labore et dolore magna aliqua. Ut enim ad minim venia quis nostrud exercitation co laboris nisi ut aliquip ex ea commodo conse.
                                            </p>
                                            <h5 className="eltdf-testimonial-author">
                                              <span className="eltdf-testimonials-author-name">Robert Chang</span>
                                            </h5>
                                            <p className="eltdf-testimonials-author-job">Sommelier</p>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default About;